var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"article_card"},[(_vm.image)?_c('img',{staticClass:"article_card__image",attrs:{"src":_vm.image}}):_vm._e(),_c('h2',{staticClass:"article_card__title"},[_vm._v(_vm._s(_vm.article.title))]),_c('div',{staticClass:"article_card__intro",domProps:{"innerHTML":_vm._s(_vm.intro)}}),_c('router-link',{staticClass:"readmore",attrs:{"to":{
        name: _vm.routename,
        params:{
          id: _vm.article.id
        }
      }}},[_vm._v("Weiterlesen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }